const BLOG_CURSOR_METAFIELDS_TUNE = `#graphql
  fragment BlogCursorMetafieldsTune on Article {
    thumbnail: metafield(namespace: "info", key: "thumbnail") {
      ...MetafieldFields
      references(first: 15) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
    video: metafield(namespace: "info", key: "video") {
      ...MetafieldFields
      reference {
        ...VideoImageFields
      }
    }
    articleTheme: metafield(namespace: "article", key: "theme") {
      ...MetafieldFields
    }
  }
`;

const BLOG_CURSOR_METAFIELDS_YESEYESEE = `#graphql
  fragment BlogCursorMetafieldsYeseyesee on Article {
    thumbnail: metafield(namespace: "info", key: "thumbnail") {
      ...MetafieldFields
      references(first: 15) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
    video: metafield(namespace: "info", key: "video") {
      ...MetafieldFields
      reference {
        ...VideoImageFields
      }
    }
  }
`;

const BLOG_CURSOR_METAFIELDS_THISISNEVERTHAT = `#graphql
  fragment BlogCursorMetafieldsThisisneverthat on Article {
    id
  }
`;

const BLOG_ARTICLE_METAFIELDS_THISISNEVERTHAT = `#graphql
  fragment BlogArticleMetafieldsThisisneverthat on Article {
    id
    collection: metafield(namespace: "operation", key: "collection") {
      ...MetafieldFields
      reference {
        ... on Collection {
          id
          handle
          title
        }
      }
    }
    video: metafield(namespace: "operation", key: "video") {
      ...MetafieldFields
      reference {
        ...VideoImageFields
      }
    }
  }
`;

/** 상세(articleByHandle) 전용. 목록까지 무거워지지 않게 관련상품은 여기서만 받는다. */
const BLOG_ARTICLE_DETAIL_METAFIELDS_THISISNEVERTHAT = `#graphql
  fragment BlogArticleDetailMetafieldsThisisneverthat on Article {
    relatedProducts: metafield(namespace: "operation", key: "related_products") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductRefFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/** 목록 카드(ArticleCard) 렌더에 필요한 최소 필드. 상세 본문/관련상품은 상세 쿼리에서만 받는다. */
const BLOG_ARTICLE_CARD_FIELDS_KHAKIS = `#graphql
  fragment BlogArticleCardFieldsKhakis on Article {
    id
    handle
    title
    tags
    publishedAt
    image {
      ...ImageFields
    }
  }
`;

/** 이전/다음 이동 + 필터 집계에만 쓰이는 커서 목록. id/handle/tags 외에는 받지 않는다. */
const BLOG_CURSOR_FIELDS_KHAKIS = `#graphql
  fragment BlogCursorFieldsKhakis on Article {
    id
    handle
    tags
  }
`;

const BLOG_CURSOR_METAFIELDS_KHAKIS = `#graphql
  fragment BlogCursorMetafieldsKhakis on Article {
    relatedProducts: metafield(namespace: "related-product", key: "list") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              tag: metafield(namespace: "info", key: "tag") {
                ...MetafieldFields
              }
              launches: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference {
                  ...MetaobjectKeyValueFields
                }
              }
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    ...VariantMetafieldsKhakis
                    product {
                      ...ProductCommonFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/** 목록 카드 렌더에 필요한 최소 필드. 상세 본문/관련상품은 상세 쿼리에서만 받는다. */
const BLOG_ARTICLE_CARD_FIELDS_SUNLOVE = `#graphql
  fragment BlogArticleCardFieldsSunlove on Article {
    id
    handle
    title
    tags
    publishedAt
    image {
      ...ImageFields
    }
  }
`;

/** 이전/다음 이동 + 태그 집계 + 룩북 목차에만 쓰이는 커서 목록. 본문/관련상품은 받지 않는다. */
const BLOG_CURSOR_FIELDS_SUNLOVE = `#graphql
  fragment BlogCursorFieldsSunlove on Article {
    id
    handle
    title
    tags
    publishedAt
  }
`;

const BLOG_CURSOR_METAFIELDS_SUNLOVE = `#graphql
  fragment BlogCursorMetafieldsSunlove on Article {
    relatedProducts: metafield(namespace: "operation", key: "related_products") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductRefFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const BLOG_ARTICLE_METAFIELDS_SUNLOVE = `#graphql
  fragment BlogArticleMetafieldsSunlove on Article {
    relatedProducts: metafield(namespace: "operation", key: "related_products") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductRefFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    articleProducts: metafield(namespace: "operation", key: "article_items") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ...MetaobjectProductRefFieldsSunlove
          }
        }
      }
    }
  }
`;

const BLOG_CURSOR_METAFIELDS_WELLBEINGEXPRESS = `#graphql
  fragment BlogCursorMetafieldsWellbeingexpress on Article {
    thumbnail: metafield(namespace: "operation", key: "thumbnail") {
      ...MetafieldFields
      references(first: 15) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
    season: metafield(namespace: "operation", key: "season") {
      ...MetafieldFields
    }
  }
`;

const BLOG_ARTICLE_METAFIELDS_WELLBEINGEXPRESS = `#graphql
  fragment BlogArticleMetafieldsWellbeingexpress on Article {
    thumbnail: metafield(namespace: "operation", key: "thumbnail") {
      ...MetafieldFields
      references(first: 15) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
    season: metafield(namespace: "operation", key: "season") {
      ...MetafieldFields
    }
    relatedProducts: metafield(namespace: "operation", key: "related_products") {
      ...MetafieldFields
      references(first: 100) {
        edges {
          node {
            ... on Product {
              ...ProductFieldsWellbeingexpress
              thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
                ...MetafieldFields
                reference {
                  ...MediaImageFields
                }
                references(first: 10) {
                  edges {
                    node {
                      ...MediaImageFields
                    }
                  }
                }
              }
              variants(first: 100) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductFieldsWellbeingexpress
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/** sunlove articleProducts가 참조하는 Metaobject → Product 목록 */
const METAOBJECT_PRODUCT_REF_FIELDS_SUNLOVE = `#graphql
  fragment MetaobjectProductRefFieldsSunlove on Metaobject {
    id
    fields {
      key
      value
      references(first: 120) {
        edges {
          node {
            ... on Product {
              ...ProductCommonFields
              brandName: metafield(namespace: "info", key: "brand_name") {
                ...MetafieldFields
              }
              hidden: metafield(namespace: "operation", key: "hidden") {
                ...MetafieldFields
              }
              variants(first: 40) {
                edges {
                  node {
                    ...VariantBaseFields
                    product {
                      ...ProductRefFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/** 이 파일의 모든 fragment (registry 등록용) */
/**
 * tenui 는 블로그를 쓰지 않는다.
 * 다만 blog-gql 의 default 오퍼레이션이 `...BlogCursorMetafields${S}` 를 보간하므로
 * (fragment 가 없으면 buildDocument 가 모듈 로드 시점에 throw 한다) 빈 fragment 를 둔다.
 */
const BLOG_CURSOR_METAFIELDS_TENUI = `#graphql
  fragment BlogCursorMetafieldsTenui on Article {
    id
  }
`;

export const BLOG_FRAGMENTS = [
  BLOG_CURSOR_METAFIELDS_TUNE,
  BLOG_CURSOR_METAFIELDS_YESEYESEE,
  BLOG_CURSOR_METAFIELDS_THISISNEVERTHAT,
  BLOG_ARTICLE_METAFIELDS_THISISNEVERTHAT,
  BLOG_ARTICLE_DETAIL_METAFIELDS_THISISNEVERTHAT,
  BLOG_ARTICLE_CARD_FIELDS_KHAKIS,
  BLOG_CURSOR_FIELDS_KHAKIS,
  BLOG_CURSOR_METAFIELDS_KHAKIS,
  BLOG_ARTICLE_CARD_FIELDS_SUNLOVE,
  BLOG_CURSOR_FIELDS_SUNLOVE,
  BLOG_CURSOR_METAFIELDS_SUNLOVE,
  BLOG_ARTICLE_METAFIELDS_SUNLOVE,
  BLOG_CURSOR_METAFIELDS_WELLBEINGEXPRESS,
  BLOG_ARTICLE_METAFIELDS_WELLBEINGEXPRESS,
  METAOBJECT_PRODUCT_REF_FIELDS_SUNLOVE,
  BLOG_CURSOR_METAFIELDS_TENUI,
];
